import Swiper, {Navigation} from "../../assets/.npm/node_modules/swiper";

export default () => {

    let swiperAc = new Swiper(".slider-activity", {
        modules: [Navigation],
        slidesPerView: 1, 
        spaceBetween: 0,
        loop: true,
        navigation: {
            nextEl: ".activity-next",
            prevEl: ".activity-prev",
        },
        breakpoints: {
            580: {
                slidesPerView: 'auto', 
            },
            992: {
                slidesPerView: '4', 
            },
        },
        on: {
            slideChange: function(){
              var currentSlide = this.realIndex + 1;
              //console.log("currentSlide is:" + currentSlide);
              document.querySelector('.activity-count .current').innerHTML = currentSlide;
            },
            beforeInit: function(){
            let numOfSlides = this.wrapperEl.querySelectorAll(".swiper-slide").length;
            document.querySelector('.activity-count .total').innerHTML = "/" + numOfSlides;
            }
          },
    });
}
  
